import React, { Suspense } from "react";
import Loader from "../General/loader";

export default function (components: any): any {
    const { Content, Sidebar } = components;

    const WithSidebar = (props: any) => {
        function getSidebar(): JSX.Element {
            if (!Sidebar) {
                return null;
            }

            return <Sidebar {...props} />;
        }

        return (
            <div className="Content">
                {getSidebar()}
                <div className="Content__details">
                    <Suspense fallback={<Loader />}>
                        <Content {...props} />
                    </Suspense>
                </div>
            </div>
        );
    };

    return WithSidebar;
}
